import { createReducer } from "typesafe-actions";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import OpenStageDealAmountCardConfiguration from "@app/types/dashboard/cards/openStageDealAmount/OpenStageDealAmountCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyOpenStageDealAmountDrillDownListViewSettings,
  fetchOpenStageDealAmountCardDrillDownData,
  hideOpenStageDealAmountDrillDown,
  OpenStageDealAmountCardActions,
  showOpenStageDealAmountDrillDown,
} from "./actions";

export interface OpenStageDealAmountCardState {
  configuration?: OpenStageDealAmountCardConfiguration;
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const openStageDealAmountInitialState: OpenStageDealAmountCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const openStageDealAmountState = createReducer<
  OpenStageDealAmountCardState,
  OpenStageDealAmountCardActions
>(openStageDealAmountInitialState)
  .handleAction(showOpenStageDealAmountDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
  }))
  .handleAction(showOpenStageDealAmountDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideOpenStageDealAmountDrillDown, (state) => ({
    ...state,
    configuration: undefined,
  }))
  .handleAction(fetchOpenStageDealAmountCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchOpenStageDealAmountCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchOpenStageDealAmountCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyOpenStageDealAmountDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default openStageDealAmountState;
